import evaluationApiClient from "common/Adapters/EvaluationApiClient/evaluationApiClient";

export function fetchOverheads(lang, data, onError, companyAccess = false) {
  return evaluationApiClient.getOverheads(lang, data, onError, companyAccess);
}

export function fetchCompanyDetail(onError, companyAccess) {
  return evaluationApiClient.getCompanyDetail(onError, companyAccess);
}

export function fetchNogaDetail(lang, nogaId, onError) {
  return evaluationApiClient.getNogaDetail(lang, nogaId, onError);
}
